// extracted by mini-css-extract-plugin
module.exports = {"inviteFaq":"Faq_inviteFaq__jHFRs","textYellow":"Faq_textYellow__HDyQN"};